module.exports = __webpack_public_path__ + "img/volunteer2.49a7fc60.png";